module.exports = __webpack_public_path__ + "img/patient_list.3dd28c64.svg";